import loadable from '@loadable/component';
import { useParams } from 'react-router-dom';
import usePostHook from '../../customHooks/usePostHook';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import Spinner from '../../components/Reusable/Spinner';
import { tw } from '@careinfo/tailwind';
const BranchListComponent = loadable(
  () => import('../../components/Branch/BranchList')
);
const BranchList = () => {
  const { slug } = useParams<{ slug: string }>();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`branch-${slug}`],
  });
  const handleAsync = async () => {
    const url = `${APIS.DELIVERY_PARTNER}${slug}/sync-branch/`;
    const formData = {};
    try {
      await mutateAsync({ url, formData, setError: () => { } });
    } catch (err) {
      console.error(err);
    }
  };

  const { data, isLoading } = useGetHook({
    queryKey: [`branch-${slug}`],
    url: `${APIS.DELIVERY_PARTNER}${slug}/branch/`,
    params: {
      limit: 10,
      offset: 0,
    },
  });

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Branch</span>
      </div>
      <BranchListComponent
        slug={slug}
        receiverLocation={data?.results}
        handleAsync={handleAsync}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default BranchList;
